import { Component, Input } from '@angular/core';
import { AppConfig } from '../../../core/services/app-config.service';
import { HandsetService } from '../../../core/services/handset.service';
import { NgStyle } from '@angular/common';
import { DefaultClassDirective } from 'ng-flex-layout';

@Component({
  standalone: true,
  selector: 'app-container',
  styleUrls: ['./container.component.scss'],
  templateUrl: './container.component.html',
  imports: [
    NgStyle,
    DefaultClassDirective,
  ],
})
export class ContainerComponent {
  @Input() public maxWidth = '1004px';
  private _noTopPadding = false;
  private _noTopPaddingMobile;
  private _sidePadding: string;
  private _sidePaddingMobile: string;

  @Input()
  set sidePadding(value: string) {
    this._sidePadding = value;
  }

  @Input()
  set sideMobilePadding(value: string) {
    this._sidePaddingMobile = value;
  }

  @Input()
  set noTopPadding(value: boolean) {
    this._noTopPadding = value;
  }

  @Input()
  set noTopPaddingMobile(value: boolean) {
    this._noTopPaddingMobile = value;
  }


  get noTopPadding() {
    if (this.handsetService.isMobile && this._noTopPaddingMobile) {
      return this._noTopPaddingMobile;
    } else {
      return this._noTopPadding;
    }
  }

  get sidePadding() {
    if (this.handsetService.isMobile && this._sidePaddingMobile) {
      return this._sidePaddingMobile;
    } else {
      return this._sidePadding;
    }
  }

  @Input() public = false;


  @Input() public noPadding = false;

  @Input() public noPaddingMobile = false;
  @Input() public sidePaddingMobile: string;

  @Input() public hasFab: boolean;
  public hasChat: boolean;


  constructor(private appConfig: AppConfig, public handsetService: HandsetService) {
    this.handsetService.handsetChanges.subscribe(
      (isHandset) =>
        (this.hasChat =
          (this.appConfig.config.analytics.intercom.enabled || this.appConfig.config.analytics.crisp.enabled) &&
          !isHandset),
    );
  }

  get getStyle() {
    const styles: { [key: string]: string } = {
      'max-width': this.maxWidth,
    };

    if (this.noPadding) {
      styles['padding'] = '0';
    } else {
      if (this.sidePadding) {
        styles['padding-left'] = this.sidePadding;
        styles['padding-right'] = this.sidePadding;
      }
      if (this.noTopPadding) {
        styles['padding-top'] = '0';
      }
    }
    const filteredStyles: { [key: string]: string } = {};
    for (const key in styles) {
      if (styles[key] !== undefined) {
        filteredStyles[key] = styles[key];
      }
    }
    return filteredStyles;
  }
  ;
}
